import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaInstagram } from "react-icons/fa";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Ajusta si tu archivo firebase.js está en otro lado

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.12 }
  })
};

const SocialMediaGallery = () => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null); // Nuevo estado

  useEffect(() => {
    // Trae máximo 8 documentos más recientes
    const fetchGallery = async () => {
      const q = query(
        collection(db, "gallery"),
        orderBy("createdAt", "desc"),
        limit(8)
      );
      const querySnapshot = await getDocs(q);
      const items = [];
      querySnapshot.forEach((doc) => {
        items.push({ id: doc.id, ...doc.data() });
      });
      setGalleryItems(items);
    };
    fetchGallery();
  }, []);
  
  // --- Gestión del botón atrás para cerrar el modal ---
  useEffect(() => {
    if (selectedItem) {
      // Cuando abres el modal, empuja un nuevo estado al historial
      window.history.pushState({ modalOpen: true }, "");

      // Al presionar atrás, cerrar el modal
      const handlePopState = () => setSelectedItem(null);
      window.addEventListener("popstate", handlePopState);

      // Cleanup: quita el listener y vuelve el historial si cierras manualmente
      return () => {
        window.removeEventListener("popstate", handlePopState);
        if (window.history.state && window.history.state.modalOpen) {
          window.history.back();
        }
      };
    }
  }, [selectedItem]);
  // --- Fin gestión botón atrás ---


  return (
    <motion.section
      className="container mx-auto py-12"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
<h2
  className="text-3xl sm:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-green-400 mb-4 text-center drop-shadow-lg"
>
  🌊 Atlantis Fish | Momentos Bajo el Agua 🐟
</h2>
<p className="text-lg text-textSecondary text-center mb-8">
  Mira nuestras instalaciones, acuarios y los peces más bonitos de Cúcuta.
</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {galleryItems.map((item, i) => (
          <motion.div
            key={item.id}
            className="rounded-xl overflow-hidden bg-gray-100 shadow group cursor-pointer"
            custom={i}
            variants={fadeIn}
            whileHover={{ scale: 1.03 }}
            onClick={() => setSelectedItem(item)} // Nuevo: abrir modal al hacer clic
          >
            {item.type === "image" ? (
              <img src={item.url} alt={item.alt || "Foto acuario"} className="w-full h-40 object-cover" />
            ) : (
              <video
                src={item.url}
                controls
                className="w-full h-40 object-cover"
                preload="none"
              />
            )}
          </motion.div>
        ))}
      </div>
      <div className="mt-10 flex justify-center">
        <a
          href="https://www.instagram.com/atlantisfish1/?hl=es"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-bold px-8 py-4 rounded-2xl shadow-lg text-lg hover:scale-105 transition-all"
        >
          <FaInstagram className="text-2xl" />
          Ver más en Instagram
        </a>
      </div>

      {/* MODAL de imagen/video */}
      {selectedItem && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
          onClick={() => setSelectedItem(null)}
          style={{ animation: "fadeIn .2s" }}
        >
          <div className="relative">
            {selectedItem.type === "image" ? (
              <img
                src={selectedItem.url}
                alt={selectedItem.alt || "Vista ampliada"}
                className="max-w-[96vw] max-h-[85vh] rounded-2xl shadow-2xl border-4 border-white"
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <video
                src={selectedItem.url}
                controls
                autoPlay
                className="max-w-[96vw] max-h-[85vh] rounded-2xl shadow-2xl border-4 border-white"
                onClick={(e) => e.stopPropagation()}
              />
            )}
            <button
              className="absolute top-3 right-3 text-white text-4xl font-bold hover:text-red-400 transition"
              onClick={() => setSelectedItem(null)}
              style={{ background: 'transparent', border: 'none' }}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </motion.section>
  );
};

export default SocialMediaGallery;
